<div class="container-fluid py-4">
    <div class="row">
        <div class="col-12">
            <div class="card mb-4">
                <div class="card-header pb-0 d-flex justify-content-between align-items-center">
                    <h5>Loguri Semnare Operator</h5>
                    <div class="d-flex gap-2">
                        <button class="btn btn-sm btn-outline-primary" (click)="toggleCard()">
                            <i class="fa-solid fa-filter me-1"></i>
                            Filtre
                        </button>
                        <button class="btn btn-sm btn-outline-success" (click)="exportCsv()" [disabled]="isExporting">
                            <i class="fa-solid fa-file-csv me-1"></i>
                            {{ isExporting ? 'Export...' : 'Export CSV' }}
                        </button>
                    </div>
                </div>

                <!-- Filters Card -->
                <div class="card-body pt-2" *ngIf="showCard">
                    <div class="row g-3">
                        <div class="col-md-3">
                            <label class="form-label small">Data de la</label>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFrom">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Data pana la</label>
                            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Status</label>
                            <select class="form-select form-select-sm" [(ngModel)]="statusFilter">
                                <option value="">Toate</option>
                                <option *ngFor="let status of statuses" [value]="status.value">
                                    {{ status.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Tip Exemplar</label>
                            <select class="form-select form-select-sm" [(ngModel)]="docExemplarTypeFilter">
                                <option value="">Toate</option>
                                <option *ngFor="let type of exemplarTypes" [value]="type.value">
                                    {{ type.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">User ID</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="userIdFilter"
                                placeholder="ID utilizator">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Nume Utilizator</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="userNameFilter"
                                placeholder="Cauta dupa nume">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Doc Generat ID</label>
                            <input type="text" class="form-control form-control-sm"
                                [(ngModel)]="documentGeneratIdFilter" placeholder="ID document generat">
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small">Doc Registratura ID</label>
                            <input type="text" class="form-control form-control-sm"
                                [(ngModel)]="documentRegistraturaIdFilter" placeholder="ID document registratura">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small">Cautare generala</label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="searchFilter"
                                placeholder="Cauta in nume, directie, compartiment, erori, IP...">
                        </div>
                        <div class="col-md-6 d-flex align-items-end gap-2">
                            <button class="btn btn-sm btn-primary" (click)="applyFilters()">
                                <i class="fa-solid fa-search me-1"></i>
                                Aplica filtre
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" (click)="resetForm()">
                                <i class="fa-solid fa-times me-1"></i>
                                Reseteaza
                            </button>
                        </div>
                    </div>
                </div>

                <!-- DataTable -->
                <div class="card-body px-0 pt-0 pb-2">
                    <div class="table-responsive p-3">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="table table-striped table-hover align-items-center mb-0 w-100">
                        </table>
                        <!-- Loading Spinner -->
                        <div class="loading-overlay" *ngIf="isLoading">
                            <mat-spinner></mat-spinner>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>